import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Breadcrumb/sgds-breadcrumb";
import { register } from "../../utils/ce-registry";

register("sgds-breadcrumb", Component);

export default createComponent({
  react: React,
  tagName: "sgds-breadcrumb",
  elementClass: Component,
  events: {}
});
